import clsx from "clsx"
import { Img, ImgProps } from "./Img"

export type ResponsiveImageProps = ImgProps

export const ResponsiveImage = (props: ResponsiveImageProps) => {
  return (
    <Img
      {...props}
      className={clsx(props.className, {
        "mx-auto": !props.className?.includes("mx-") && !props.className?.includes("m-"),
        "max-w-full": !props.className?.includes("max-w-"),
        "w-full": !props.className?.includes("w-") && !props.className?.includes("size-"),
        "h-auto": !props.className?.includes("h-") && !props.className?.includes("size-"),
      })}
    />
  )
}
